var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mg-select-tree',_vm._g(_vm._b({ref:"mgSelectTree",attrs:{"data":_vm.item.data}},'mg-select-tree',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }